export default class CPFValidator {
    private static calcChecker1(firstNineDigits: string) {
    let sum: number = 0;

    for (let j: number = 0; j < 9; ++j) {
      sum += (Number(firstNineDigits.charAt(j)) * (10 - j));
    }

    const lastSumChecker1 = sum % 11;
    const checker1 = lastSumChecker1 < 2 ? 0 : 11 - lastSumChecker1;

    return checker1;
  }

  private static calcChecker2(cpfWithChecker1: string) {
    let sum = 0;

    for (let k = 0; k < 10; ++k) {
      sum += Number(cpfWithChecker1.charAt(k)) * (11 - k);
    }
    const lastSumChecker2 = sum % 11;
    const checker2 = lastSumChecker2 < 2 ? 0 : 11 - lastSumChecker2;

    return checker2;
  }

  private static cleaner(value: string) {
    const digits = value.replace(/[^\d]/g, "");
    return digits;
  }

  static validate(value: string) {
    const cleanCPF = CPFValidator.cleaner(value);
    const firstNineDigits = cleanCPF.substring(0, 9);
    const checker = cleanCPF.substring(9, 11);
    let result = false;

    for (let i = 0; i < 10; i++) {
      if (firstNineDigits + checker === Array(12).join(i.toString())) {
        return false;
      }
    }

    const checker1 = CPFValidator.calcChecker1(firstNineDigits);
    const checker2 = CPFValidator.calcChecker2(`${firstNineDigits}${checker1}`);

    if (checker.toString() === checker1.toString() + checker2.toString()) {
      result = true;
    } else {
      result = false;
    }
    return result;
  }
}